export default "/images/vendor/flag-icon-css/flags/4x3/fj.svg?f3d86add9fe9ed6722749f8a0f21fc1d";